import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthCallbackComponent} from './components/auth-callback/auth-callback.component';
import {ShouldLoginComponent} from './components/should-login/should-login.component';

export const authRoutes: Routes = [
  {
    path: 'signin-oidc',
    component: AuthCallbackComponent,
    data: {
      title: 'Authorizing'
    }
  },
  {
    path: 'should-login',
    component: ShouldLoginComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(authRoutes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
}
